import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { GiveAwardModel } from '../../models/admin/give-award-model';
import { ResetPasswordOverrideModel } from '../../models/admin/reset-password-override-model';
import { AdminIcon } from '../../models/admin/admin-icon';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private http = inject(HttpClient);

  icons = signal<AdminIcon[]>([]);

  getIcons() {
    this.http.get<AdminIcon[]>(environment.platformUrl + 'api/icon/list').subscribe({
      next: (icons) => this.icons.set(icons),
      error: (err) => console.error('Failed to load admin icons', err),
    });
  }

  overridePassword(model: ResetPasswordOverrideModel) {
    return this.http.post(environment.oAuthApiUrl + 'api/account/override', model);
  }

  giveAward(model: GiveAwardModel) {
    return this.http.post(environment.platformUrl + 'api/admin/award', model);
  }
}
